import React from 'react';
import styled from 'styled-components';

interface IIcon {
  $size?: string;
}

export const Icon = styled.svg.attrs<IIcon>((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  $size: props.$size || '1em',
  'aria-hidden': true,
})).withConfig({ componentId: 'sc-1hd03rn-0' })`
    display: block;
    width: ${({ $size }: IIcon) => $size};
    height: ${({ $size }: IIcon) => $size};
    fill: currentColor;
`;

export const StrokeIcon = styled(Icon).withConfig({ componentId: 'sc-1hd03rn-1' })`
    fill: none;
    stroke: currentColor;
`;

export const IconArrowLeft = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m.8 7.2 4.8-4.8 1.7 1.7-2.7 2.7h10.2c.7 0 1.2.5 1.2 1.2s-.5 1.2-1.2 1.2H4.5l2.8 2.7-1.7 1.7L.8 8.8 0 8l.8-.8Z" />
  </Icon>
);

export const IconArrowRight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m15.2 8.8-4.8 4.8-1.7-1.7 2.7-2.7H1.2C.5 9.2 0 8.7 0 8s.5-1.2 1.2-1.2h10.3L8.7 4.1l1.7-1.7 4.8 4.8.8.8-.8.8z" />
  </Icon>
);

export const IconBookmark = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M8 6v11.178l3.463-2.204a1 1 0 0 1 1.074 0L16 17.178V6H8ZM6.47 4.486A1.62 1.62 0 0 1 7.625 4h8.75c.437 0 .852.177 1.155.486.303.308.47.722.47 1.15V19a1 1 0 0 1-1.537.844L12 17.004l-4.463 2.84A1 1 0 0 1 6 19V5.636c0-.428.167-.842.47-1.15Z" />
  </Icon>
);

export const IconBulb = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M7 2V1c0-.6.4-1 1-1s1 .4 1 1v1c0 .6-.4 1-1 1s-1-.4-1-1zM2.3 4.7c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-1-1c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1 1zm12.4-1c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-1 1c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l1-1zm-2.4 2.6c.5.7.7 1.5.7 2.4 0 .8-.2 1.6-.7 2.3-.3.5-.8 1-1.3 1.3V15c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-2.7c-.5-.3-1-.8-1.3-1.3-.5-.7-.7-1.5-.7-2.4 0-.8.2-1.6.7-2.3.4-.7 1.1-1.3 1.8-1.7C6.3 4.2 7.1 4 8 4c.9 0 1.7.2 2.5.6.7.4 1.4 1 1.8 1.7zM11 8.6c0-.4-.1-.9-.4-1.3-.2-.3-.6-.7-1.1-.9C9.1 6.1 8.6 6 8 6c-.5 0-1.1.1-1.5.4-.5.2-.9.5-1.1.9-.3.4-.4.9-.4 1.3s.1.9.4 1.3c.3.4.6.7 1.1 1 .3.2.5.5.5.9V14h2v-2.2c0-.4.2-.7.5-.9.5-.2.8-.6 1.1-1 .3-.4.4-.8.4-1.3zM15 7h-.5c-.6 0-1 .4-1 1s.4 1 1 1h.5c.6 0 1-.4 1-1s-.4-1-1-1zM1.5 7H1c-.6 0-1 .4-1 1s.4 1 1 1h.5c.6 0 1-.4 1-1s-.4-1-1-1z" />
  </Icon>
);

export const IconCalendar = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M13 1h-1V0h-2v1H6V0H4v1H3C1.3 1 0 2.3 0 4v9c0 1.7 1.3 3 3 3h10c1.7 0 3-1.3 3-3V4c0-1.7-1.3-3-3-3zm1 12c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V8h12v5zm0-7H2V4c0-.6.4-1 1-1h1v1h2V3h4v1h2V3h1c.6 0 1 .4 1 1v2z" />
  </Icon>
);

export const IconCar = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15.9 9.6 15 7.7l-.8-5.1c-.2-.9-1-1.6-1.9-1.6H3.7c-.9 0-1.7.7-1.9 1.6L1 7.7.1 9.6c-.1.1-.1.2-.1.4v2c0 .6.4 1 1 1v1c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1h6v1c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-1c.6 0 1-.4 1-1v-2c0-.2 0-.3-.1-.4zM3.8 3h8.5l.6 4H3.2l.6-4zM2 11v-.8L2.6 9h10.8l.6 1.2v.8H2z" />
  </Icon>
);

export const IconCheck = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M12.3 3.8 6 10.1 3.7 7.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.4.4 1 .4 1.4 0l7-7c.4-.4.4-1 0-1.4s-1-.4-1.4 0z" />
  </Icon>
);

export const IconChevronDown = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m3 5.9.8-.9L8 9.3 12.2 5l.8.9-4.2 4.3-.8.8-.8-.9L3 5.9z" />
  </Icon>
);

export const IconChevronLeft = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M11.4 0l1.4 1.3L5.9 8l6.9 6.7-1.4 1.3-6.9-6.7L3.2 8l1.4-1.3L11.4 0z" />
  </Icon>
);

export const IconChevronRight = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M4.6 16l-1.4-1.3L10.1 8 3.2 1.3 4.6 0l6.9 6.7L12.8 8l-1.4 1.3L4.6 16z" />
  </Icon>
);

export const IconChevronUp = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m13 10.1-.8.9L8 6.7 3.8 11l-.8-.9 4.2-4.3L8 5l.8.9 4.2 4.2z" />
  </Icon>
);

export const IconClose = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m9.4 8 3.5 3.5-1.4 1.4L8 9.4l-3.5 3.5-1.4-1.4L6.6 8 3.1 4.5l1.4-1.4L8 6.6l3.5-3.5 1.4 1.4L9.4 8z" />
  </Icon>
);

export const IconCopy = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M20.25 2.625h-12A1.125 1.125 0 0 0 7.125 3.75v3.375H3.75A1.125 1.125 0 0 0 2.625 8.25v12a1.125 1.125 0 0 0 1.125 1.125h12a1.125 1.125 0 0 0 1.125-1.125v-3.375h3.375a1.125 1.125 0 0 0 1.125-1.125v-12a1.125 1.125 0 0 0-1.125-1.125Zm-5.625 16.5h-9.75v-9.75h9.75v9.75Zm4.5-4.5h-2.25V8.25a1.125 1.125 0 0 0-1.125-1.125H9.375v-2.25h9.75v9.75Z" />
  </Icon>
);

export const IconDot = (props: IIcon) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path d="M14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" />
  </Icon>
);

export const IconDownload = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4a1 1 0 0 1 1 1v7.586l2.293-2.293 1.414 1.414-4 4-.707.707-.707-.707-4-4 1.414-1.414L11 12.586V5a1 1 0 0 1 1-1ZM5 18h14v2H5v-2Z"
    />
  </Icon>
);

export const IconLightning = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="m13.3 7.3-5.5 5.5c-.6.6-1.4 0-1.2-.7l1.1-3.2H3.2c-.6 0-.9-.8-.5-1.2l5.5-5.5c.6-.6 1.4 0 1.2.7L8.3 6.1h4.5c.6 0 .9.8.5 1.2z" />
  </Icon>
);

export const IconExclamation = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M7.1 9.6 6.7 2h2.7L9 9.6H7.1zM8 11c-.8 0-1.5.7-1.5 1.5S7.2 14 8 14s1.5-.7 1.5-1.5S8.8 11 8 11z" />
  </Icon>
);

export const IconInfo = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M7 7h2v6H7V7zm0-4v2h2V3H7z" />
  </Icon>
);

export const IconKebab = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M14 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </Icon>
);

export const IconHeart = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M21.172 5.075a5.819 5.819 0 0 0-8.205-.013l-.967.9-.967-.899a5.813 5.813 0 1 0-8.211 8.232l8.377 8.498a1.125 1.125 0 0 0 1.603 0l8.37-8.493a5.814 5.814 0 0 0 0-8.222v-.002ZM19.58 11.71 12 19.397l-7.582-7.692a3.563 3.563 0 1 1 5.068-5.011l1.747 1.627a1.125 1.125 0 0 0 1.534 0l1.747-1.627.03-.027a3.562 3.562 0 1 1 5.032 5.044h.003Z" />
  </Icon>
);

export const IconHeartFilled = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22.5 9.188a5.402 5.402 0 0 1-1.594 3.843l-8.372 8.496a.751.751 0 0 1-1.068 0L3.094 13.03a5.44 5.44 0 0 1 7.687-7.697L12 6.474l1.227-1.143A5.437 5.437 0 0 1 22.5 9.187Z" />
  </Icon>
);

export const IconHelpCircle = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm-1.4-3.8h1.9V12H6.6v-1.8zm3.8-3.4c0 1-.5 1.5-1.4 2l-.4.3c-.3.1-.3.2-.3.4v.1H6.7v-.3c0-.6.1-.9.8-1.3l.7-.4c.3-.2.6-.4.6-.8s-.3-.7-.7-.7c-.5 0-.8.3-.8.8v.3H5.7v-.4c0-1.2.8-2 2.3-2 1.5 0 2.4.7 2.4 2z" />
  </Icon>
);

export const IconMileage = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M8 2.5c-4.4 0-8 3.6-8 8 0 .8.1 1.5.3 2.3l.3.7h14.9l.2-.7c.2-.7.3-1.5.3-2.3 0-4.4-3.6-8-8-8zm6 9H8.8L7 7.1l-1.8.8 1.4 3.6H2.2c-.1-.3-.1-.7-.1-1 0-3.3 2.7-6 6-6s6 2.7 6 6c0 .3 0 .7-.1 1z" />
  </Icon>
);

export const IconMinus = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M19 13H5v-2h14v2Z" />
  </Icon>
);

export const IconPlay = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M22.5 12a1.477 1.477 0 0 1-.712 1.267L8.28 21.53a1.5 1.5 0 0 1-2.075-.517 1.487 1.487 0 0 1-.205-.75V3.737a1.487 1.487 0 0 1 .761-1.296 1.5 1.5 0 0 1 1.519.028l13.508 8.263A1.476 1.476 0 0 1 22.5 12Z" />
  </Icon>
);

export const IconPlus = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M14 7v2H9v5H7V9H2V7h5V2h2v5h5z" />
  </Icon>
);

export const IconSearch = (props: IIcon) => (
  <StrokeIcon viewBox="0 0 24 24" {...props}>
    <path
      d="M17.3069 11.6534c0 3.3985-2.755 6.1534-6.1535 6.1534C7.755 17.8068 5 15.0519 5 11.6534 5 8.255 7.755 5.5 11.1534 5.5c3.3985 0 6.1535 2.755 6.1535 6.1534ZM20 19.5l-4-4"
      strokeWidth="2"
    />
  </StrokeIcon>
);

export const IconShare = (props: IIcon) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path d="M16.5 14.625a4.104 4.104 0 0 0-2.727 1.031L9.947 13.2a4.131 4.131 0 0 0 0-2.4l3.826-2.456a4.11 4.11 0 1 0-1.219-1.891L8.727 8.906a4.125 4.125 0 1 0 0 6.182l3.826 2.462a4.125 4.125 0 1 0 3.947-2.925Zm0-11.25a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75ZM6 13.875a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Zm10.5 6.75a1.875 1.875 0 1 1 0-3.751 1.875 1.875 0 0 1 0 3.751Z" />
  </Icon>
);

export const IconTrash = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M11 13H9V7h2v6zM7 7H5v6h2V7zm9-4v2h-1v10c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V5H0V3h4V1c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v2h4zM6 3h4V2H6v1zm7 2H3v9h10V5z" />
  </Icon>
);

export const IconTrendUp = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15.6 3.8v7h-2V7.2l-5 5-4-4L2 10.8c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4-4 4 4 3.6-3.6H8.6v-2h7z" />
  </Icon>
);

export const IconTrendDown = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15.6 5.2v7h-7v-2h3.6L8.6 6.6l-4 4-4-4c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2.6 2.6 4-4 5 5V5.2h2z" />
  </Icon>
);

export const IconMenu = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M16 1v2H0V1h16zM0 9h16V7H0v2zm0 6h16v-2H0v2z" />
  </Icon>
);

export const IconUser = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15 16h-2c0-1.7-1.3-3-3-3H6c-1.7 0-3 1.3-3 3H1c0-2.8 2.2-5 5-5h4c2.8 0 5 2.2 5 5zM4 5V4c0-2.2 1.8-4 4-4s4 1.8 4 4v1c0 2.2-1.8 4-4 4S4 7.2 4 5zm2 0c0 1.1.9 2 2 2s2-.9 2-2V4c0-1.1-.9-2-2-2s-2 .9-2 2v1z" />
  </Icon>
);

export const IconWarning = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M15.8 13.2L9.1 1.5c-.5-.9-1.7-.9-2.2 0L.2 13.2c-.5.9.1 1.9 1.1 1.9h13.4c1 0 1.6-1.1 1.1-1.9zm-1.1.7H1.3c-.1 0-.1-.1-.1-.2L7.9 2.1c0-.1.1-.1.2 0l6.7 11.6c0 .1 0 .2-.1.2zM8.6 6.4v3.4c0 .3-.3.6-.6.6s-.6-.3-.6-.6V6.4c0-.4.3-.6.6-.6s.6.2.6.6zm0 5.3v.3c0 .3-.3.6-.6.6s-.6-.2-.6-.6v-.4c0-.3.3-.6.6-.6s.6.4.6.7z" />
  </Icon>
);

export const IconQuote = (props: IIcon) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path d="M16 1.2V7c0 3.2-.9 5.8-2 7.8H9.9c1.2-2.1 2.3-4.6 2.5-7h-3V1.2H16zM0 7.8h3c-.1 2.4-1.2 4.9-2.5 7h4.1c1.1-1.9 2-4.6 2-7.8V1.2H0v6.6z" />
  </Icon>
);
